import { AuthProvider } from "@descope/react-sdk";

// Il token di sessione viaggia solo in HTTPS e mai su richieste cross-site.
// Resta leggibile da JS: HttpOnly lo puo' impostare solo chi emette il cookie lato server.
export const SESSION_COOKIE = { sameSite: "Strict", secure: true };

export const AuthWrapper = ({ children }) => {
	if (process.env.REACT_APP_SSO_LOGIN_DESCOPE_ENABLED !== 'true') {
		return <>{children}</>;
	}
	return (
		<AuthProvider
			projectId={`${process.env.REACT_APP_OIDC_CLIENT_ID}`}
			sessionTokenViaCookie={SESSION_COOKIE}
			oidcConfig={{
				applicationId: `${process.env.REACT_APP_DESCOPE_OIDC_APPLICATION_ID}`,
			}}
			baseUrl={`${process.env.REACT_APP_API_SICUREZZA_DESCOPE_BASE_URL}`}
		>
			{children}
		</AuthProvider>
	);
};

export default AuthWrapper;